var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClasses,style:(_vm.styles)},[_c('canvas',{ref:"canvas",attrs:{"id":_vm.chartId,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }